import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../../../root/tcsm-model';

export function useCurrentEmployerHook(){
	return useSelector<TcsmStates, string>(state => state.institutionState?.currentInstitution?.org_guid);
}

export function useCurrentEmployerClientIdHook() {
	return useSelector<TcsmStates, string>(state => state.institutionState?.currentInstitution?.org_client_nbr);
}